import { FlexRow } from '@/components/common/Flex';
import { Box, FlexProps } from '@chakra-ui/react';
import { TickRange } from '@common/valueSeries';
import { ParentSize } from '@visx/responsive';
import {
    ChartRangeSelector,
    ChartRangeStepperButton,
    ChartRangeType,
} from '../common/charts/ChartRangeControls';
import ErrorBoundary from '../common/ErrorBoundary';
import GoalsChart, { GoalsChartEntityParams } from './GoalsChart';

const GoalsChartContainer = ({
    chartEntities,
    range,
    chartRangeType,
    onIncrement,
    onDecrement,
    onChangeType,
    ...props
}: {
    chartEntities: GoalsChartEntityParams[];
    range: TickRange;
    chartRangeType: ChartRangeType;
    onIncrement: VoidFunction;
    onDecrement: VoidFunction;
    onChangeType: (type: ChartRangeType) => void;
} & FlexProps) => {
    return (
        <FlexRow shrink={0} grow={0} h={280} {...props}>
            <Box h="full" w="full" position="relative">
                <ChartRangeSelector
                    top={-1.5}
                    type={chartRangeType}
                    onChange={onChangeType}
                />
                <ChartRangeStepperButton
                    type="decrement"
                    onClick={onDecrement}
                />
                <ChartRangeStepperButton
                    type="increment"
                    onClick={onIncrement}
                />
                <ParentSize>
                    {(parent) => (
                        <ErrorBoundary>
                            <GoalsChart
                                entities={chartEntities}
                                width={parent.width}
                                height={parent.height}
                                range={range}
                            />
                        </ErrorBoundary>
                    )}
                </ParentSize>
            </Box>
        </FlexRow>
    );
};

export default GoalsChartContainer;
